<template>
  <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 25 24" fill="none">
    <circle cx="12.3" cy="12" r="12" fill="white"></circle>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.35938 12C1.35938 18.0751 6.28424 23 12.3594 23C18.4345 23 23.3594 18.0751 23.3594 12C23.3594 5.92487 18.4345 1 12.3594 1C6.28424 1 1.35938 5.92487 1.35938 12ZM8.96045 11.8273C8.62552 11.4654 8.04702 11.4315 7.66833 11.7516C7.28964 12.0717 7.25416 12.6245 7.58909 12.9863L10.5264 16.16L17.3011 9.4837C17.6531 9.13687 17.6442 8.58308 17.2812 8.24677C16.9183 7.91045 16.3388 7.91897 15.9868 8.2658L10.5882 13.586L8.96045 11.8273Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'Checkmark',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
